import {
  Button,
  Divider,
  IconButton,
  Stack,
  createStyles,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import LinkIcon from "@mui/icons-material/Link";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddIcon from "@mui/icons-material/Add";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import React, { useEffect, useState } from "react";
import { black } from "../../utils/StyleHelpers";
import { useContentStore } from "../../stores/contentStore";
import { locale } from "../../utils/LocaleManager";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";

const buttonStyle = createStyles({
  color: black,
  textTransform: "none",
});

const ContextMenu = (props: any) => {
  const selectedThumbnails = useContentStore(
    (state: any) => state.selectedThumbnails,
  );
  const setSelectedThumbnails = useContentStore(
    (state: any) => state.setSelectedThumbnails,
  );
  const setIsShowDeleteDialog = useContentStore(
    (state: any) => state.setIsShowDeleteDialog,
  );
  const setIsShowVerticalAssignmentDialog = useContentStore(
    (state: any) => state.setIsShowVerticalAssignmentDialog,
  );
  const rolePermissions = useRolePermissionsStore(
    (state: any) => state.rolePermissions,
  );
  const [isMultiple, setIsMultiple] = useState(false);

  useEffect(() => {
    setIsMultiple(selectedThumbnails.length > 1);
  }, [selectedThumbnails]);

  const isShowActionStack =
    (!props.isBrowseOnly &&
      !props?.isShowDetails &&
      rolePermissions?.video?.move) ||
    (!props.isBrowseOnly && rolePermissions?.video?.retag) ||
    (!props.isBrowseOnly && !isMultiple && rolePermissions?.video?.rename) ||
    (!props.isBrowseOnly && rolePermissions?.video?.delete);
  const isShowSecondaryActionStack =
    !props?.isShowDetails &&
    !props.isBrowseOnly &&
    (rolePermissions?.video?.retag ||
      (!isMultiple && rolePermissions?.video?.download));

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      flexWrap={"wrap"}
      divider={<Divider orientation="vertical" flexItem />}
      style={{
        background: "#F0F4F8",
        borderRadius: "0.5rem",
        padding: "0.25rem",
        gap: "2.5rem",
        alignItems: "center",
        marginBottom: "2.5rem",
        marginTop: "1rem",
        visibility: props?.isShow || props?.isShowPlayer ? "visible" : "hidden",
      }}
      justifyContent={props?.isShowPlayer ? "center" : ""}
    >
      {props?.isShowPlayer ? (
        ""
      ) : (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          flexWrap={"wrap"}
          spacing={3}
        >
          <Stack direction="row">
            <IconButton
              aria-label="clear"
              onClick={() => setSelectedThumbnails([])}
            >
              <ClearIcon />
            </IconButton>
            <Button variant="text" disabled={true} style={buttonStyle}>
              {`${selectedThumbnails.length} ${locale.control_selected}`}
            </Button>
          </Stack>
          {!isMultiple && rolePermissions?.video?.view === true && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<PlayCircleOutlineIcon fontSize="small" />}
              onClick={() => {
                if (useRolePermissionsStore.getState().rolePermissions?.video?.view === true) {
                  props.onClickPlay();
                }
              }}
            >
              {locale.control_play}
            </Button>
          )}
        </Stack>
      )}

      <Stack
        direction={{ xs: "column", sm: "row" }}
        flexWrap={"wrap"}
        spacing={2}
      >
        {(!props.isBrowseOnly || props.isShowPlayer) &&
          !isMultiple &&
          rolePermissions?.video?.view === true &&
          props.onCopyLinks && (
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<LinkIcon fontSize="small" />}
            onClick={() => {
              if (useRolePermissionsStore.getState().rolePermissions?.video?.view === true) {
                props.onCopyLinks();
              }
            }}
          >
            {locale.control_copy}
          </Button>
        )}
        {rolePermissions?.video?.download && (
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<FileDownloadOutlinedIcon fontSize="small" />}
            onClick={props.onDownload}
          >
            {locale.control_download}
          </Button>
        )}
        {props.isShowDetails ? (
          <></>
        ) : (
          !isMultiple && rolePermissions?.video?.view === true && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<InfoOutlinedIcon fontSize="small" />}
              onClick={() => {
                if (useRolePermissionsStore.getState().rolePermissions?.video?.view === true) {
                  props.onClickDetails();
                }
              }}
            >
              {locale.control_details}
            </Button>
          )
        )}
      </Stack>
      {isShowActionStack && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          spacing={2}
        >
          {!props.isBrowseOnly && !props?.isShowDetails && rolePermissions?.video?.move && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<DriveFileMoveOutlinedIcon fontSize="small" />}
              onClick={props.onClickMove}
              sx={{
                ":disabled": {
                  opacity: "0.5",
                },
              }}
            >
              {locale.control_move}
            </Button>
          )}
          {!props.isBrowseOnly && rolePermissions?.video?.retag && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<CategoryOutlinedIcon fontSize="small" />}
              onClick={() => {
                if (
                  useRolePermissionsStore.getState().rolePermissions?.video
                    ?.retag === true
                ) {
                  setIsShowVerticalAssignmentDialog(true);
                }
              }}
              aria-label={
                selectedThumbnails.length > 1
                  ? "Assign selected videos to verticals"
                  : "Assign selected video to vertical"
              }
              sx={{
                ":disabled": {
                  opacity: "0.5",
                },
              }}
            >
              {locale.control_assign_to_vertical}
            </Button>
          )}
          {props.onUnassignVertical && rolePermissions?.video?.retag && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<CategoryOutlinedIcon fontSize="small" />}
              onClick={() => {
                if (
                  useRolePermissionsStore.getState().rolePermissions?.video
                    ?.retag === true
                ) {
                  props.onUnassignVertical();
                }
              }}
            >
              {locale.control_unassign_from_vertical}
            </Button>
          )}
          {!props.isBrowseOnly && !isMultiple && rolePermissions?.video?.rename && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={
                <DriveFileRenameOutlineOutlinedIcon fontSize="small" />
              }
              onClick={props.onClickRename}
              sx={{
                ":disabled": {
                  opacity: "0.5",
                },
              }}
            >
              {locale.control_rename}
            </Button>
          )}
          {!props.isBrowseOnly && rolePermissions?.video?.delete && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}
              onClick={() => setIsShowDeleteDialog(true)}
            >
              {locale.control_delete}
            </Button>
          )}
        </Stack>
      )}
      {isShowSecondaryActionStack && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          spacing={2}
        >
          {!props.isBrowseOnly && rolePermissions?.video?.retag && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<AddIcon fontSize="small" />}
              onClick={props.onClickRetag}
              sx={{
                ":disabled": {
                  opacity: "0.5",
                },
              }}
            >
              {locale.add_tag}
            </Button>
          )}
          {!props.isBrowseOnly && !isMultiple && rolePermissions?.video?.download && (
            <Button
              variant="text"
              style={buttonStyle}
              startIcon={<IosShareOutlinedIcon fontSize="small" />}
              onClick={props.onClickExport}
              sx={{
                ":disabled": {
                  opacity: "0.5",
                },
              }}
            >
              {locale.exportTranscript}
            </Button>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default ContextMenu;
